

import React, { memo } from 'react';

import './_mention-tag.scss';






function MentionTag({ offsetkey, children }) {
  return (
    <span data-offset-key={offsetkey} className="mention-tag">{children}</span>);

}

export default memo(MentionTag);